var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"px-3",attrs:{"elevation":"0"}},[_c('v-card-title',{staticClass:"text-h4"},[_vm._v(" Kiosk Billing Management "),_c('v-spacer')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }